import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { detectBrowserLang, useLocale } from "@/hooks/use-locale";
import { LANG_LABELS } from "@/lib/translations.functions";

const DISMISS_KEY = "sa.lang.banner.dismissed";

/**
 * Shows a one-time banner offering to switch to the visitor's browser language
 * when it differs from the current locale.
 */
export function LanguageBanner() {
  const [lang, setLang] = useLocale();
  const [suggest, setSuggest] = useState<string | null>(null);

  useEffect(() => {
    try {
      if (window.localStorage.getItem(DISMISS_KEY)) return;
      const detected = detectBrowserLang();
      if (detected !== "en" && detected !== lang) setSuggest(detected);
    } catch {}
  }, [lang]);

  if (!suggest) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-40 mx-auto max-w-md rounded-2xl border border-primary/40 bg-card/95 p-3 shadow-lg backdrop-blur md:bottom-6">
      <div className="flex items-center gap-3">
        <p className="flex-1 text-sm text-foreground">
          Read in {LANG_LABELS[suggest as keyof typeof LANG_LABELS]}?
        </p>
        <button
          onClick={() => {
            setLang(suggest as any);
            try { window.localStorage.setItem(DISMISS_KEY, "1"); } catch {}
            setSuggest(null);
          }}
          className="rounded-full bg-primary px-3 py-1.5 text-xs font-bold uppercase text-primary-foreground"
        >
          Switch
        </button>
        <button
          onClick={() => {
            try { window.localStorage.setItem(DISMISS_KEY, "1"); } catch {}
            setSuggest(null);
          }}
          aria-label="Dismiss"
          className="rounded-full p-1 text-muted-foreground hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
